(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produktfinder"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-vw-pf]').forEach(init);

  // External trigger: any link whose href ends in the finder sentinel opens the
  // finder popup (no navigation). Requires a Produktfinder section on the page.
  if (!window.__vwOpenFinderBound) {
    window.__vwOpenFinderBound = true;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href$="#vw-open-finder"]');
      if (!trigger) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('vw:open-finder'));
    });
  }

  function init(root) {
    var products = JSON.parse(root.querySelector('[data-vw-pf-products]').textContent);
    var panels = Array.prototype.slice.call(root.querySelectorAll('.vw-pf__step'));
    var stepPanels = panels.filter(function (p) { return p.getAttribute('data-step') !== 'result'; });
    var resultPanel = root.querySelector('[data-step="result"]');
    var progressBar = root.querySelector('.vw-pf__progress-bar');
    var nextBtn = root.querySelector('[data-vw-pf-next]');
    var backBtn = root.querySelector('[data-vw-pf-back]');
    var stickyAdd = root.querySelector('[data-vw-pf-sticky-add]');
    var barPrice = root.querySelector('[data-vw-pf-bar-price]');
    var resultWrap = root.querySelector('[data-vw-pf-result]');
    var nameOuts = root.querySelectorAll('[data-vw-pf-dogname]');
    var modal = root.querySelector('[data-vw-pf-modal]');
    var openBtn = root.querySelector('[data-vw-pf-open]');

    var state = { concerns: [], name: '', age: '', breed: '', size: '', mode: 'abo' };
    var index = 0; // 0..stepPanels.length-1, then 'result'
    var atResult = false;

    function fmt(c) { return 'CHF ' + (c / 100).toFixed(2); }

    function show() {
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      if (atResult) {
        resultPanel.classList.add('is-active');
        progressBar.style.width = '100%';
        nextBtn.style.display = 'none';
        backBtn.hidden = false;
        if (stickyAdd) stickyAdd.hidden = false;
        if (barPrice) barPrice.hidden = false;
        renderResult();
      } else {
        stepPanels[index].classList.add('is-active');
        progressBar.style.width = ((index + 1) / stepPanels.length * 100) + '%';
        nextBtn.style.display = '';
        nextBtn.textContent = index === stepPanels.length - 1 ? 'Ergebnis anzeigen' : 'Weiter';
        backBtn.hidden = index === 0;
        if (stickyAdd) stickyAdd.hidden = true;
        if (barPrice) barPrice.hidden = true;
        syncNext();
      }
    }

    function syncNext() {
      // Only step 1 (concern) is required to advance.
      var ok = true;
      if (index === 0) ok = state.concerns.length > 0;
      nextBtn.disabled = !ok;
    }

    function updateNames() {
      var label = state.name && state.name.trim() ? state.name.trim() : 'deinen Hund';
      var labelDat = state.name && state.name.trim() ? state.name.trim() : 'dein Hund';
      nameOuts.forEach(function (el) {
        // step3/step4 use nominative-ish "dein Hund"; result uses accusative "deinen Hund".
        el.textContent = el.closest('[data-step="result"]') ? label : (state.name && state.name.trim() ? state.name.trim() : labelDat);
      });
    }

    // Concern cards
    root.querySelectorAll('[data-concern]').forEach(function (card) {
      card.addEventListener('click', function () {
        var key = card.getAttribute('data-concern');
        var pos = state.concerns.indexOf(key);
        if (pos === -1) { state.concerns.push(key); card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true'); }
        else { state.concerns.splice(pos, 1); card.classList.remove('is-selected'); card.setAttribute('aria-pressed', 'false'); }
        syncNext();
      });
    });

    var unsure = root.querySelector('[data-vw-pf-unsure]');
    if (unsure) unsure.addEventListener('click', function () {
      state.concerns = ['gelenke', 'ruhe', 'verdauung'];
      atResult = false; index = 1; show();
    });

    // Name
    var nameInput = root.querySelector('[data-vw-pf-name]');
    if (nameInput) nameInput.addEventListener('input', function () { state.name = nameInput.value; updateNames(); });
    var breedInput = root.querySelector('[data-vw-pf-breed]');
    if (breedInput) breedInput.addEventListener('input', function () { state.breed = breedInput.value; });

    // Age / size single-select groups
    root.querySelectorAll('[data-vw-pf-group]').forEach(function (group) {
      var field = group.getAttribute('data-vw-pf-group');
      group.querySelectorAll('.vw-pf__choice').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.vw-pf__choice').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state[field] = btn.getAttribute('data-' + field);
        });
      });
    });

    nextBtn.addEventListener('click', function () {
      if (index === stepPanels.length - 1) { atResult = true; show(); }
      else { index++; show(); }
    });
    backBtn.addEventListener('click', function () {
      if (atResult) { atResult = false; index = stepPanels.length - 1; }
      else if (index > 0) { index--; }
      show();
    });

    function matchedKeys() {
      var order = ['gelenke', 'ruhe', 'verdauung'];
      return order.filter(function (k) { return state.concerns.indexOf(k) !== -1; });
    }

    function stars(r) {
      var filled = Math.round(r);
      var s = '';
      for (var i = 1; i <= 5; i++) {
        s += '<span style="color:' + (i <= filled ? '#C9A063' : 'rgba(27,58,47,.22)') + '">★</span>';
      }
      return s;
    }

    function renderResult() {
      updateNames();
      var keys = matchedKeys();
      if (!keys.length) keys = ['gelenke', 'ruhe', 'verdauung'];

      var mode = '<div class="vw-pf__mode">'
        + '<input type="radio" name="vw-pf-mode" id="vw-pf-abo" value="abo" ' + (state.mode === 'abo' ? 'checked' : '') + '>'
        + '<label for="vw-pf-abo">Im Abo sparen<small>jederzeit kündbar</small></label>'
        + '<input type="radio" name="vw-pf-mode" id="vw-pf-once" value="einmalig" ' + (state.mode === 'einmalig' ? 'checked' : '') + '>'
        + '<label for="vw-pf-once">Einmalig kaufen<small>ohne Bindung</small></label>'
        + '</div>';

      var cards = keys.map(function (k) {
        var p = products[k];
        var once = p.priceCents, sub = (p.subCents && p.subCents < once) ? p.subCents : once, save = once - sub;
        var priceHtml = (state.mode === 'abo' && save > 0)
          ? '<span class="once">' + fmt(once) + '</span><span class="sub">' + fmt(sub) + '</span><span class="save">Du sparst ' + fmt(save) + '</span>'
          : '<span class="sub">' + fmt(state.mode === 'abo' ? sub : once) + '</span>';
        return '<div class="vw-pf__rc">'
          + (p.img ? '<img src="' + p.img + '" alt="' + p.title + '">' : '<img alt="">')
          + '<div class="vw-pf__rc-body">'
          + '<p class="vw-pf__rc-title">' + p.title + '</p>'
          + (p.ratingCount ? '<div class="vw-pf__rc-stars">' + stars(p.rating) + '<span class="vw-pf__rc-rating-count">(' + p.ratingCount + ' Bewertungen)</span></div>' : '')
          + '<p class="vw-pf__rc-why">Darum passt das: ' + p.why + '</p>'
          + (function () {
              var ings = (p.ingredients || []);
              if (!ings.length) return '';
              return '<ul class="vw-pf__ings">' + ings.map(function (g) {
                return '<li class="vw-pf__ing"><div class="vw-pf__ing-media">'
                  + (g.img ? '<img class="vw-pf__ing-img" src="' + g.img + '" alt="' + (g.t || '') + '" width="120" height="120" loading="lazy">' : '<span class="vw-pf__ing-img vw-pf__ing-img--ph" aria-hidden="true"></span>')
                  + '</div><div class="vw-pf__ing-text">'
                  + (g.t ? '<h4 class="vw-pf__ing-title">' + g.t + '</h4>' : '')
                  + (g.a ? '<p class="vw-pf__ing-abstract">' + g.a + '</p>' : '')
                  + '</div></li>';
              }).join('') + '</ul>';
            })()
          + '<div class="vw-pf__rc-price">' + priceHtml + '</div>'
          + '<button class="vw-pf__rc-atc" data-key="' + k + '">In den Warenkorb</button>'
          + '</div></div>';
      }).join('');

      resultWrap.innerHTML = mode + cards;

      if (barPrice) {
        var tOnce = 0, tSub = 0;
        keys.forEach(function (k) {
          var p = products[k];
          var o = p.priceCents, s = (p.subCents && p.subCents < o) ? p.subCents : o;
          tOnce += o; tSub += s;
        });
        var tSave = tOnce - tSub;
        barPrice.innerHTML = (state.mode === 'abo' && tSave > 0)
          ? '<span class="once">' + fmt(tOnce) + '</span><span class="sub">' + fmt(tSub) + '</span><span class="save">Du sparst ' + fmt(tSave) + '</span>'
          : '<span class="sub">' + fmt(state.mode === 'abo' ? tSub : tOnce) + '</span>';
      }

      resultWrap.querySelectorAll('input[name="vw-pf-mode"]').forEach(function (r) {
        r.addEventListener('change', function () { state.mode = r.value; renderResult(); });
      });

      resultWrap.querySelectorAll('[data-key]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var k = btn.getAttribute('data-key');
          var p = products[k];
          btn.disabled = true;
          btn.textContent = 'Wird hinzugefügt …';
          var item = { id: p.id, quantity: 1, properties: { 'Für': state.name && state.name.trim() ? state.name.trim() : 'deinen Hund' } };
          if (state.mode === 'abo' && p.plan) item.selling_plan = p.plan;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
            .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { btn.disabled = false; btn.textContent = 'Erneut versuchen'; });
        });
      });

      var addAllBtn = root.querySelector('[data-vw-pf-add]');
      if (addAllBtn) addAllBtn.style.display = keys.length > 1 ? '' : 'none';
    }

    function submitAdd(btn) {
      var keys = matchedKeys();
      if (!keys.length) keys = ['gelenke', 'ruhe', 'verdauung'];
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt ...';

      var items = keys.map(function (k) {
        var p = products[k];
        var item = { id: p.id, quantity: 1, properties: { 'Für': state.name && state.name.trim() ? state.name.trim() : 'deinen Hund' } };
        if (state.mode === 'abo' && p.plan) item.selling_plan = p.plan;
        return item;
      });

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: {
              'dog_name': state.name, 'dog_age': state.age, 'dog_size': state.size,
              'concern': keys.join(', '), 'dog_breed': state.breed
            } })
          });
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Erneut versuchen'; });
    }

    var addBtn = root.querySelector('[data-vw-pf-add]');
    if (addBtn) addBtn.addEventListener('click', function () { submitAdd(addBtn); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { submitAdd(stickyAdd); });

    function openModal() { if (!modal) return; modal.hidden = false; document.documentElement.style.overflow = 'hidden'; show(); }
    function closeModal() { if (!modal) return; modal.hidden = true; document.documentElement.style.overflow = ''; }
    if (openBtn) openBtn.addEventListener('click', openModal);
    document.addEventListener('vw:open-finder', openModal);
    root.querySelectorAll('[data-vw-pf-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

    // Blog finder button: /pages/produkte#produktfinder opens the finder at step 1, with NO pre-fill.
    try {
      if (modal && window.location.hash === '#produktfinder') {
        atResult = false;
        index = 0;
        openModal();
      }
    } catch (e) {}

    show();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-article-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-vw-rg-sticky]');
    if (!bar) return;
    if (sessionStorage.getItem('vwRgStickyClosed') === '1') { bar.style.display = 'none'; return; }
    var close = bar.querySelector('[data-vw-rg-sticky-close]');
    if (close) close.addEventListener('click', function () {
      bar.style.display = 'none';
      try { sessionStorage.setItem('vwRgStickyClosed', '1'); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
